import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { lastValueFrom } from 'rxjs';
import { BusyIndicatorMessageManager } from '../../../Busy-Indicator';
import { TaxDotComDocsSvcLogRepository } from '../taxDotComDocsSvcLog.repository';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { TaxDotComDocsSvcLogDetailsGridComponent } from './taxDotComDocsSvcLogDetailsGrid.component';

export interface TaxDotComDocsSvcLogDetailsParams {
    summaryLogId: number;
}

@Component({
    selector: 'taxdotcom-docs-svc-log-details-modal',
    templateUrl: './taxDotComDocsSvcLogDetailsModal.component.html',
    styleUrls: ['./taxDotComDocsSvcLogDetailsModal.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class TaxDotComDocsSvcLogDetailsModalComponent implements OnInit, IWeissmanModalComponent<TaxDotComDocsSvcLogDetailsParams, void> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _taxDotComDocsSvcLogRepository: TaxDotComDocsSvcLogRepository) {
    }

    @ViewChild('taxDotComDocsSvcLogDetailsGrid') taxDotComDocsSvcLogDetailsGrid: TaxDotComDocsSvcLogDetailsGridComponent;

    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();

    params: TaxDotComDocsSvcLogDetailsParams;
    result: void;

    taxDotComDocsSvcDiagnosticsDetail: Core.TaxDotComDocsSvcDiagnosticsDetailModel;

    async ngOnInit(): Promise<void> {
        const busyMsgId = 'loading';
        this.busyIndicatorMessageManager.add('Loading Tax.com Documents Service Log Details', busyMsgId);

        const searchParams: Core.TaxDotComDocsSvcDiagnosticsDetailSearchModel = {
            summaryLogId: this.params.summaryLogId
        };

        try {
            this.taxDotComDocsSvcDiagnosticsDetail = await lastValueFrom(this._taxDotComDocsSvcLogRepository.getDetail(searchParams));
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    cancel(): void {
        this._bsModalRef.hide();
    }
}
